// extracted by mini-css-extract-plugin
export var deleteIcon = "_on-5";
export var deleteOption = "_on-3";
export var divider = "_on-2";
export var downloadIcon = "_on-4";
export var drawer = "_on-0";
export var drawerFooter = "_on-6";
export var drawerOpen = "_on-1";
export var highlighted = "_on-7";
export var lighterHighlight = "_on-8";